import { Children, isValidElement } from 'react'
import type { ReactNode } from 'react'

export function getReactNodeEntries(children: ReactNode): Array<{
  key: string
  node: ReactNode
}> {
  const keyOccurrences = new Map<string, number>()

  return Children.toArray(children).map((node) => {
    const semanticKey = isValidElement(node)
      ? String(node.key)
      : `${typeof node}:${String(node)}`
    const occurrence = (keyOccurrences.get(semanticKey) ?? 0) + 1
    keyOccurrences.set(semanticKey, occurrence)

    return { key: `${semanticKey}:${occurrence}`, node }
  })
}
